import React from 'react';
import './Header.css'
import DateHour from './Date';

const Header = () => {
    return ( 
        <>
            <div className='header-date'>
                <h1>Minhas Tarefas</h1>
            </div>
        </>
     );
}
 
export default Header;